import { css, html, LitElement } from 'lit-element';
import './ki-icon';
import '@polymer/paper-tooltip/paper-tooltip';

export default class KiIconBtn extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      display: block;
      color: gray;
      background: white;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12),
        0 3px 1px -2px rgba(0, 0, 0, 0.2);
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 40px;
      cursor: pointer;
      position: relative;
    }
    :host(:hover) ki-icon::part(icon){
      fill: #4a4a49;
    }

    :host(.ripple) {
      background-position: center;
      transition: background 0.8s;
    }
    :host(.ripple:hover) {
     backgrounda: #47a7f5 radial-gradient(circle, transparent 1%, #47a7f5 1%) center/15000%;
    }
    :host(.ripple:active) {
      background-color: var(--theme-color-secondary, #0056a0);
      background-size: 100%;
      transition: background 0s;
    }

    :host(.disabled) {
      pointer-events: none;
      opacity: 0.5;
    }
  `;

  constructor() {
    super();
    this.icon = 'ki ki-th';
  }

  static get properties() {
    return {
      icon: { type: String },
      tooltip: { type: String },
      disabled: { type: Boolean },
    };
  }

  render() {
    // language=html
    return html`
      <ki-icon @click="${this.showTooltip}" .icon=${this.icon}></ki-icon>
      <paper-tooltip position="bottom" manual-mode animation-delay="0">${this.tooltip}</paper-tooltip>
    `;
  }

  showTooltip(){
    if(this.tooltip){
    this.renderRoot.querySelector('paper-tooltip').show()
      setTimeout(()=> {
        this.renderRoot.querySelector('paper-tooltip').hide()
      }, 5000)
    }
  }
}

customElements.define('ki-icon-btn', KiIconBtn);
